$desktop-large-breakpoint: 1440px;
$desktop-small-breakpoint: 1280px;
$tablet-breakpoint: 840px;
$mobile-breakpoint: 480px;

:export {
  desktopBreakpoint: $desktop-small-breakpoint - 1;
}

@mixin centered-container {
  max-width: 1440px;
  padding: 0 104px;
  margin: 0 auto;

  @media only screen and (min-width: $desktop-small-breakpoint) and (max-width: $desktop-large-breakpoint) {
    padding: 0 24px;
  }

  @media only screen and (max-width: $tablet-breakpoint) {
    padding: 0 48px;
  }

  @media only screen and (max-width: $mobile-breakpoint) {
    padding: 0 16px;
  }
}

.top-level-header-container {
  padding: 0.4rem 0;
  box-shadow: 0 0.8rem 2.4rem #dcdce1;

  & > * {
    @include centered-container;
  }
}

.top-level-layout-container {
  @include centered-container;

  &__side-navigation {
    flex: 0 1 300px;
    margin-right: 3.2rem;
  }

  &__content {
    flex: 1 1 900px;
    min-width: 0;
  }
}
